module.exports = __webpack_public_path__ + "assets/ef029e03fa3cbdb91795adbd38da09a5.jpg";